import { Link, useNavigate } from "react-router-dom";
import { Clapperboard, LogOut, Plus } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const TopNav = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate("/");
  };

  return (
    <nav className="mvp-nav" data-testid="top-nav">
      <Link to={user ? "/dashboard" : "/"} className="mvp-nav-brand" data-testid="nav-brand">
        <Clapperboard size={22} />
        <span>Anim8<em>TV</em></span>
      </Link>
      <div className="mvp-nav-actions">
        {user ? (
          <>
            <Link to="/create" className="btn-primary mvp-nav-btn" data-testid="nav-create-btn">
              <Plus size={16} /> New Project
            </Link>
            <span className="mvp-nav-user" data-testid="nav-username">{user.username}</span>
            <button className="mvp-nav-ghost" onClick={handleLogout} data-testid="nav-logout-btn">
              <LogOut size={16} />
            </button>
          </>
        ) : (
          <Link to="/auth" className="btn-primary mvp-nav-btn" data-testid="nav-login-btn">
            Sign In
          </Link>
        )}
      </div>
    </nav>
  );
};
